import { helper as buildHelper } from "@ember/component/helper";
import { htmlSafe } from "@ember/template";

export function cssWidth(value /* , hash */) {
  return htmlSafe(`width: ${value}%`);
}

export default buildHelper(cssWidth);
